export const STUDIO_PROJECTS_COLLECTION = "studio_projects";
export const STUDIO_PROJECT_AUDIT_COLLECTION = "studio_project_audit";
export const STUDIO_CONNECTIONS_COLLECTION = "studio_connections";
export const STUDIO_CONNECTION_AUDIT_COLLECTION = "studio_connection_audit";
export const STUDIO_CONNECTION_HISTORY_COLLECTION = "studio_connection_history";
export const STUDIO_LICENSES_COLLECTION = "studio_licenses";
export const STUDIO_LICENSE_AUDIT_COLLECTION = "studio_license_audit";

export const STUDIO_USERS_COLLECTION = "studio_users";
export const STUDIO_ROLES_COLLECTION = "studio_roles";
export const STUDIO_PERMISSIONS_COLLECTION = "studio_permissions";
export const STUDIO_TEAMS_COLLECTION = "studio_teams";
export const STUDIO_DEPARTMENTS_COLLECTION = "studio_departments";
export const STUDIO_INVITATIONS_COLLECTION = "studio_invitations";
export const STUDIO_SESSIONS_COLLECTION = "studio_sessions";
export const STUDIO_USER_ACTIVITY_COLLECTION = "studio_user_activity";
export const STUDIO_ROLE_TEMPLATES_COLLECTION = "studio_role_templates";
export const STUDIO_APPROVALS_COLLECTION = "studio_approvals";
export const STUDIO_IAM_AUDIT_COLLECTION = "studio_iam_audit";

export const STUDIO_ORGANIZATIONS_COLLECTION = "studio_organizations";
export const STUDIO_BRANDING_COLLECTION = "studio_branding";
export const STUDIO_THEMES_COLLECTION = "studio_themes";
export const STUDIO_EMAIL_TEMPLATES_COLLECTION = "studio_email_templates";
export const STUDIO_REPORT_TEMPLATES_COLLECTION = "studio_report_templates";
export const STUDIO_LOGIN_BRANDING_COLLECTION = "studio_login_branding";
export const STUDIO_DESKTOP_BRANDING_COLLECTION = "studio_desktop_branding";
export const STUDIO_CUSTOM_ASSETS_COLLECTION = "studio_custom_assets";
export const STUDIO_BRANDING_AUDIT_COLLECTION = "studio_branding_audit";

export const STUDIO_NOTIFICATIONS_COLLECTION = "studio_notifications";
export const STUDIO_JOBS_COLLECTION = "studio_jobs";
export const STUDIO_HEALTH_COLLECTION = "studio_health";
export const STUDIO_USAGE_COLLECTION = "studio_usage";
export const STUDIO_ALERTS_COLLECTION = "studio_alerts";
export const STUDIO_MAINTENANCE_COLLECTION = "studio_maintenance";
export const STUDIO_OPERATION_LOGS_COLLECTION = "studio_operation_logs";

export const STUDIO_API_KEYS_COLLECTION = "studio_api_keys";
export const STUDIO_WEBHOOKS_COLLECTION = "studio_webhooks";
export const STUDIO_API_LOGS_COLLECTION = "studio_api_logs";
export const STUDIO_INTEGRATIONS_COLLECTION = "studio_integrations";
export const STUDIO_AUTOMATION_RULES_COLLECTION = "studio_automation_rules";
export const STUDIO_CLI_TOKENS_COLLECTION = "studio_cli_tokens";
export const STUDIO_SDK_CONFIGS_COLLECTION = "studio_sdk_configs";
export const STUDIO_DEVELOPER_AUDIT_COLLECTION = "studio_developer_audit";

export const STUDIO_CLOUD_SETTINGS_COLLECTION = "studio_cloud_settings";
export const STUDIO_CLOUD_JOBS_COLLECTION = "studio_cloud_jobs";
export const STUDIO_CLOUD_SCHEDULER_COLLECTION = "studio_cloud_scheduler";
export const STUDIO_CLOUD_WEBHOOKS_COLLECTION = "studio_cloud_webhooks";
export const STUDIO_CLOUD_WEBHOOK_HISTORY_COLLECTION = "studio_cloud_webhook_history";
export const STUDIO_CLOUD_API_TOKENS_COLLECTION = "studio_cloud_api_tokens";
export const STUDIO_CLOUD_LOGS_COLLECTION = "studio_cloud_logs";
export const STUDIO_CLOUD_METRICS_COLLECTION = "studio_cloud_metrics";
export const STUDIO_CLOUD_UPDATES_COLLECTION = "studio_cloud_updates";
export const STUDIO_CLOUD_TELEMETRY_COLLECTION = "studio_cloud_telemetry";
export const STUDIO_CLOUD_NODES_COLLECTION = "studio_cloud_nodes";

export const STUDIO_RELEASE_BUILDS_COLLECTION = "studio_release_builds";
export const STUDIO_RELEASE_DEPLOYMENTS_COLLECTION = "studio_release_deployments";
export const STUDIO_RELEASE_BACKUPS_COLLECTION = "studio_release_backups";
export const STUDIO_RELEASE_REPORTS_COLLECTION = "studio_release_reports";
export const STUDIO_RELEASE_ERRORS_COLLECTION = "studio_release_errors";

export const STUDIO_AI_SESSIONS_COLLECTION = "studio_ai_sessions";
export const STUDIO_AI_HISTORY_COLLECTION = "studio_ai_history";
export const STUDIO_AI_PROMPTS_COLLECTION = "studio_ai_prompts";

export const STUDIO_AGENTS_COLLECTION = "studio_agents";
export const STUDIO_AGENT_TASKS_COLLECTION = "studio_agent_tasks";
export const STUDIO_AGENT_SCHEDULES_COLLECTION = "studio_agent_schedules";
export const STUDIO_AGENT_WORKFLOWS_COLLECTION = "studio_agent_workflows";
export const STUDIO_AGENT_APPROVALS_COLLECTION = "studio_agent_approvals";
export const STUDIO_AGENT_HISTORY_COLLECTION = "studio_agent_history";
export const STUDIO_AGENT_EVENTS_COLLECTION = "studio_agent_events";
export const STUDIO_AGENT_RECOMMENDATIONS_COLLECTION = "studio_agent_recommendations";
export const STUDIO_AGENT_TIMELINE_COLLECTION = "studio_agent_timeline";
export const STUDIO_AGENT_HEALTH_COLLECTION = "studio_agent_health";
export const STUDIO_AGENT_METRICS_COLLECTION = "studio_agent_metrics";

export const STUDIO_WORKFLOWS_COLLECTION = "studio_workflows";
export const STUDIO_WORKFLOW_RUNS_COLLECTION = "studio_workflow_runs";
export const STUDIO_WORKFLOW_TEMPLATES_COLLECTION = "studio_workflow_templates";
export const STUDIO_WORKFLOW_HISTORY_COLLECTION = "studio_workflow_history";
export const STUDIO_WORKFLOW_VARIABLES_COLLECTION = "studio_workflow_variables";
export const STUDIO_WORKFLOW_TRIGGERS_COLLECTION = "studio_workflow_triggers";
export const STUDIO_WORKFLOW_APPROVALS_COLLECTION = "studio_workflow_approvals";
export const STUDIO_WORKFLOW_LOGS_COLLECTION = "studio_workflow_logs";

export const STUDIO_RECENT_KEY = "firestoreStudio.recentProjects";
export const STUDIO_THEME_KEY = "firestoreStudio.darkMode";
export const STUDIO_WORKSPACE_KEY = "firestoreStudio.workspace";
export const STUDIO_ACTIVATION_KEY = "firestoreStudio.activation";
export const STUDIO_DEVICE_ID_KEY = "firestoreStudio.deviceId";
export const STUDIO_ORG_KEY = "firestoreStudio.activeOrganization";

export const PROJECT_ENVIRONMENTS = [
  { value: "production", label: "Production" },
  { value: "testing", label: "Testing" },
  { value: "development", label: "Development" },
];

export const CONNECTION_ENVIRONMENTS = [
  { value: "production", label: "Production" },
  { value: "testing", label: "Testing" },
  { value: "development", label: "Development" },
  { value: "demo", label: "Demo" },
  { value: "sandbox", label: "Sandbox" },
];

export const CONNECTION_STATUSES = [
  { value: "online", label: "Online", color: "success" },
  { value: "warning", label: "Warning", color: "warning" },
  { value: "offline", label: "Offline", color: "default" },
  { value: "failed", label: "Failed", color: "error" },
  { value: "unknown", label: "Unknown", color: "default" },
];

export const STUDIO_NAV = [
  { id: "projects", path: "", label: "Projects", icon: "folder", requiresLicense: true },
  { id: "connections", path: "connections", label: "Connections", icon: "link", requiresLicense: true },
  { id: "connection-center", path: "connections/center", label: "Connection Center", icon: "centerHealth", requiresLicense: true },
  { id: "licenses", path: "licenses", label: "Licenses", icon: "license" },
  { id: "renewals", path: "renewals", label: "Renewals", icon: "renewal" },
];

/** Auto-refresh intervals for the Enterprise Connection Center live monitoring. */
export const CONNECTION_MONITOR_INTERVALS = [
  { value: 0, label: "Off" },
  { value: 5 * 60 * 1000, label: "5 min" },
  { value: 15 * 60 * 1000, label: "15 min" },
  { value: 30 * 60 * 1000, label: "30 min" },
  { value: 60 * 60 * 1000, label: "1 hour" },
];

/** Overall grade thresholds (based on combined connection score, 0-100). */
export const CONNECTION_GRADE_THRESHOLDS = [
  { grade: "A+", min: 97, color: "success" },
  { grade: "A", min: 90, color: "success" },
  { grade: "B", min: 80, color: "info" },
  { grade: "C", min: 70, color: "warning" },
  { grade: "D", min: 0, color: "error" },
];

/** Live health tiers mapped from health score / status. */
export const CONNECTION_HEALTH_TIERS = [
  { tier: "healthy", label: "Healthy", color: "success", min: 90 },
  { tier: "warning", label: "Warning", color: "warning", min: 70 },
  { tier: "critical", label: "Critical", color: "error", min: 1 },
  { tier: "offline", label: "Offline", color: "default", min: 0 },
];

/** Notification triggers surfaced by the Connection Center. */
export const CONNECTION_NOTIFICATION_TRIGGERS = [
  { id: "firestore_offline", label: "Firestore Offline", severity: "error" },
  { id: "storage_offline", label: "Storage Offline", severity: "warning" },
  { id: "auth_offline", label: "Authentication Offline", severity: "error" },
  { id: "project_deleted", label: "Project Deleted", severity: "error" },
  { id: "rules_changed", label: "Rules Changed", severity: "warning" },
  { id: "health_below_70", label: "Health below 70%", severity: "warning" },
];

export const CONNECTION_MONITOR_STORAGE_KEY = "firestoreStudio.connectionCenter.monitorInterval";

export const STUDIO_IAM_NAV = [
  { id: "iam-users", path: "iam/users", label: "Users", icon: "person" },
  { id: "iam-teams", path: "iam/teams", label: "Teams", icon: "group" },
  { id: "iam-roles", path: "iam/roles", label: "Roles", icon: "shield" },
  { id: "iam-permissions", path: "iam/permissions", label: "Permissions", icon: "matrix" },
  { id: "iam-sessions", path: "iam/sessions", label: "Sessions", icon: "session" },
  { id: "iam-activity", path: "iam/activity", label: "Activity", icon: "activity" },
  { id: "iam-invitations", path: "iam/invitations", label: "Invitations", icon: "mail" },
  { id: "iam-departments", path: "iam/departments", label: "Departments", icon: "dept" },
];

export const STUDIO_BRANDING_NAV = [
  { id: "brand-company", path: "branding/company", label: "Company Profile", icon: "company" },
  { id: "brand-identity", path: "branding/identity", label: "Brand Identity", icon: "identity" },
  { id: "brand-themes", path: "branding/themes", label: "Themes", icon: "palette" },
  { id: "brand-login", path: "branding/login", label: "Login Branding", icon: "login" },
  { id: "brand-dashboard", path: "branding/dashboard", label: "Dashboard Branding", icon: "dashboard" },
  { id: "brand-reports", path: "branding/reports", label: "Reports", icon: "report" },
  { id: "brand-emails", path: "branding/emails", label: "Email Templates", icon: "email" },
  { id: "brand-desktop", path: "branding/desktop", label: "Desktop Branding", icon: "desktop" },
  { id: "brand-preview", path: "branding/preview", label: "Preview", icon: "preview" },
];

export const STUDIO_OPS_NAV = [
  { id: "ops-overview", path: "operations", label: "Overview", icon: "opsOverview" },
  { id: "ops-health", path: "operations/health", label: "Health", icon: "opsHealth" },
  { id: "ops-jobs", path: "operations/jobs", label: "Jobs", icon: "opsJobs" },
  { id: "ops-notifications", path: "operations/notifications", label: "Notifications", icon: "opsNotify" },
  { id: "ops-logs", path: "operations/logs", label: "Logs", icon: "opsLogs" },
  { id: "ops-storage", path: "operations/storage", label: "Storage", icon: "opsStorage" },
  { id: "ops-performance", path: "operations/performance", label: "Performance", icon: "opsPerf" },
  { id: "ops-usage", path: "operations/usage", label: "Usage", icon: "opsUsage" },
  { id: "ops-alerts", path: "operations/alerts", label: "Alerts", icon: "opsAlerts" },
  { id: "ops-maintenance", path: "operations/maintenance", label: "Maintenance", icon: "opsMaint" },
];

export const STUDIO_DEV_NAV = [
  { id: "dev-keys", path: "developer/keys", label: "API Keys", icon: "devKeys" },
  { id: "dev-webhooks", path: "developer/webhooks", label: "Webhooks", icon: "devWebhooks" },
  { id: "dev-rest", path: "developer/rest", label: "REST API", icon: "devRest" },
  { id: "dev-sdk", path: "developer/sdk", label: "SDK", icon: "devSdk" },
  { id: "dev-automation", path: "developer/automation", label: "Automation", icon: "devAutomation" },
  { id: "dev-cli", path: "developer/cli", label: "CLI", icon: "devCli" },
  { id: "dev-integrations", path: "developer/integrations", label: "Integrations", icon: "devIntegrations" },
  { id: "dev-docs", path: "developer/docs", label: "Documentation", icon: "devDocs" },
  { id: "dev-playground", path: "developer/playground", label: "Playground", icon: "devPlayground" },
  { id: "dev-logs", path: "developer/logs", label: "API Logs", icon: "devLogs" },
];

export const STUDIO_DESKTOP_NAV = [
  { id: "desktop-settings", path: "desktop/settings", label: "Desktop Settings", icon: "desktopSettings" },
  { id: "desktop-diagnostics", path: "desktop/diagnostics", label: "Diagnostics", icon: "desktopDiag" },
];

export const STUDIO_CLOUD_NAV = [
  { id: "cloud-dashboard", path: "cloud", label: "Cloud Dashboard", icon: "cloudDashboard" },
  { id: "cloud-api", path: "cloud/api-gateway", label: "API Gateway", icon: "cloudApi" },
  { id: "cloud-workers", path: "cloud/workers", label: "Background Workers", icon: "cloudWorkers" },
  { id: "cloud-scheduler", path: "cloud/scheduler", label: "Scheduler", icon: "cloudScheduler" },
  { id: "cloud-webhooks", path: "cloud/webhooks", label: "Webhook Queue", icon: "cloudWebhooks" },
  { id: "cloud-automation", path: "cloud/automation", label: "Automation Runtime", icon: "cloudAutomation" },
  { id: "cloud-logs", path: "cloud/logs", label: "Cloud Logs", icon: "cloudLogs" },
  { id: "cloud-storage", path: "cloud/storage", label: "Cloud Storage", icon: "cloudStorage" },
  { id: "cloud-telemetry", path: "cloud/telemetry", label: "Telemetry", icon: "cloudTelemetry" },
  { id: "cloud-settings", path: "cloud/settings", label: "System Settings", icon: "cloudSettings" },
];

export const STUDIO_RELEASE_NAV = [
  { id: "release-center", path: "release", label: "Release Center", icon: "releaseCenter" },
  { id: "release-readiness", path: "release/readiness", label: "Production Readiness", icon: "releaseReadiness" },
  { id: "release-database", path: "release/database", label: "Database Health", icon: "releaseDatabase" },
  { id: "release-recovery", path: "release/recovery", label: "Disaster Recovery", icon: "releaseRecovery" },
  { id: "release-deployment", path: "release/deployment", label: "Deployment", icon: "releaseDeployment" },
  { id: "release-observability", path: "release/observability", label: "Observability", icon: "releaseObservability" },
  { id: "release-docs", path: "release/docs", label: "Documentation", icon: "releaseDocs" },
  { id: "release-licenses", path: "release/licenses", label: "License Compliance", icon: "releaseLicenses" },
];

export const STUDIO_AI_NAV = [
  { id: "ai-assistant", path: "ai", label: "AI Assistant", icon: "aiAssistant" },
  { id: "ai-query", path: "ai/query", label: "Query Generator", icon: "aiQuery" },
  { id: "ai-reports", path: "ai/reports", label: "Report Generator", icon: "aiReports" },
  { id: "ai-insights", path: "ai/insights", label: "Database Insights", icon: "aiInsights" },
  { id: "ai-schema", path: "ai/schema", label: "Schema Analyzer", icon: "aiSchema" },
  { id: "ai-cleaner", path: "ai/cleaner", label: "Data Cleaner", icon: "aiCleaner" },
  { id: "ai-prompts", path: "ai/prompts", label: "Prompt Library", icon: "aiPrompts" },
  { id: "ai-settings", path: "ai/settings", label: "AI Settings", icon: "aiSettings" },
  { id: "ai-usage", path: "ai/usage", label: "Usage Dashboard", icon: "aiUsage" },
];

export const STUDIO_AGENTS_NAV = [
  { id: "agents-dashboard", path: "agents/dashboard", label: "Dashboard", icon: "agentsDashboard" },
  { id: "agents-live", path: "agents/live", label: "Live Monitor", icon: "agentsLive" },
  { id: "agents-list", path: "agents/list", label: "Agents", icon: "agentsList" },
  { id: "agents-recommendations", path: "agents/recommendations", label: "Recommendations", icon: "agentsRecommendations" },
  { id: "agents-timeline", path: "agents/timeline", label: "Timeline", icon: "agentsTimeline" },
  { id: "agents-metrics", path: "agents/metrics", label: "Metrics", icon: "agentsMetrics" },
  { id: "agents-rules", path: "agents/rules", label: "Rule Builder", icon: "agentsRules" },
  { id: "agents-health", path: "agents/health", label: "Health Monitor", icon: "agentsHealth" },
  { id: "agents-tasks", path: "agents/tasks", label: "Tasks", icon: "agentsTasks" },
  { id: "agents-schedules", path: "agents/schedules", label: "Schedules", icon: "agentsSchedules" },
  { id: "agents-notifications", path: "agents/notifications", label: "Notifications", icon: "agentsNotifications" },
  { id: "agents-approvals", path: "agents/approvals", label: "Approvals", icon: "agentsApprovals" },
  { id: "agents-workflows", path: "agents/workflows", label: "Workflows", icon: "agentsWorkflows" },
  { id: "agents-history", path: "agents/history", label: "History", icon: "agentsHistory" },
  { id: "agents-settings", path: "agents/settings", label: "Settings", icon: "agentsSettings" },
];

export const STUDIO_WORKFLOWS_NAV = [
  { id: "wf-dashboard", path: "workflows", label: "Dashboard", icon: "wfDashboard" },
  { id: "wf-designer", path: "workflows/designer", label: "Designer", icon: "wfDesigner" },
  { id: "wf-templates", path: "workflows/templates", label: "Templates", icon: "wfTemplates" },
  { id: "wf-runs", path: "workflows/runs", label: "Runs", icon: "wfRuns" },
  { id: "wf-history", path: "workflows/history", label: "History", icon: "wfHistory" },
  { id: "wf-approvals", path: "workflows/approvals", label: "Approvals", icon: "wfApprovals" },
  { id: "wf-triggers", path: "workflows/triggers", label: "Triggers", icon: "wfTriggers" },
  { id: "wf-settings", path: "workflows/settings", label: "Settings", icon: "wfSettings" },
];

export const DELETE_CONFIRM_PHRASE = "DELETE PROJECT";
export const DELETE_CONNECTION_PHRASE = "DELETE CONNECTION";
export const DELETE_LICENSE_PHRASE = "DELETE LICENSE";

export const LICENSE_TYPES = [
  { value: "trial", label: "Trial", revenue: 0 },
  { value: "monthly", label: "Monthly", revenue: 49 },
  { value: "yearly", label: "Yearly", revenue: 499 },
  { value: "lifetime", label: "Lifetime", revenue: 1999 },
  { value: "enterprise", label: "Enterprise", revenue: 999 },
];

export const LICENSE_STATUSES = [
  { value: "active", label: "Active", color: "success" },
  { value: "expired", label: "Expired", color: "error" },
  { value: "suspended", label: "Suspended", color: "warning" },
  { value: "revoked", label: "Revoked", color: "error" },
];

export const LICENSE_FEATURES = [
  { key: "multiProject", label: "Multi Project" },
  { key: "workspace", label: "Workspace" },
  { key: "bulkUpdate", label: "Bulk Update" },
  { key: "bulkDelete", label: "Bulk Delete" },
  { key: "backup", label: "Backup" },
  { key: "restore", label: "Restore" },
  { key: "scheduler", label: "Scheduler" },
  { key: "ai", label: "AI" },
  { key: "whiteLabel", label: "White Label" },
  { key: "teamManagement", label: "Team Management" },
  { key: "api", label: "API" },
  { key: "plugins", label: "Plugins" },
  { key: "desktop", label: "Desktop" },
  { key: "export", label: "Export" },
  { key: "import", label: "Import" },
];

export const DEFAULT_ALLOWED_FEATURES = Object.fromEntries(
  LICENSE_FEATURES.map((f) => [f.key, true])
);

export const READ_ONLY_BLOCKED_FEATURES = ["bulkDelete", "bulkUpdate", "import", "restore", "scheduler"];

export const PROJECT_QUERY_KEY = ["studio", "projects"];
export const PROJECT_AUDIT_QUERY_KEY = ["studio", "project-audit"];
export const CONNECTION_QUERY_KEY = ["studio", "connections"];
export const CONNECTION_AUDIT_QUERY_KEY = ["studio", "connection-audit"];
export const CONNECTION_HISTORY_QUERY_KEY = ["studio", "connection-history"];
export const CONNECTION_CENTER_QUERY_KEY = ["studio", "connection-center"];
export const LICENSE_QUERY_KEY = ["studio", "licenses"];
export const LICENSE_AUDIT_QUERY_KEY = ["studio", "license-audit"];

export const IAM_USERS_KEY = ["studio", "iam", "users"];
export const IAM_ROLES_KEY = ["studio", "iam", "roles"];
export const IAM_TEAMS_KEY = ["studio", "iam", "teams"];
export const IAM_DEPARTMENTS_KEY = ["studio", "iam", "departments"];
export const IAM_INVITATIONS_KEY = ["studio", "iam", "invitations"];
export const IAM_SESSIONS_KEY = ["studio", "iam", "sessions"];
export const IAM_ACTIVITY_KEY = ["studio", "iam", "activity"];
export const IAM_TEMPLATES_KEY = ["studio", "iam", "templates"];
export const IAM_APPROVALS_KEY = ["studio", "iam", "approvals"];
export const IAM_AUDIT_KEY = ["studio", "iam", "audit"];

export const BRAND_ORGS_KEY = ["studio", "branding", "organizations"];
export const BRAND_CONFIG_KEY = ["studio", "branding", "config"];
export const BRAND_THEMES_KEY = ["studio", "branding", "themes"];
export const BRAND_ASSETS_KEY = ["studio", "branding", "assets"];
export const BRAND_LOGIN_KEY = ["studio", "branding", "login"];
export const BRAND_DASHBOARD_KEY = ["studio", "branding", "dashboard"];
export const BRAND_EMAILS_KEY = ["studio", "branding", "emails"];
export const BRAND_REPORTS_KEY = ["studio", "branding", "reports"];
export const BRAND_DESKTOP_KEY = ["studio", "branding", "desktop"];
export const BRAND_AUDIT_KEY = ["studio", "branding", "audit"];

export const OPS_OVERVIEW_KEY = ["studio", "ops", "overview"];
export const OPS_HEALTH_KEY = ["studio", "ops", "health"];
export const OPS_JOBS_KEY = ["studio", "ops", "jobs"];
export const OPS_NOTIFICATIONS_KEY = ["studio", "ops", "notifications"];
export const OPS_LOGS_KEY = ["studio", "ops", "logs"];
export const OPS_STORAGE_KEY = ["studio", "ops", "storage"];
export const OPS_PERFORMANCE_KEY = ["studio", "ops", "performance"];
export const OPS_USAGE_KEY = ["studio", "ops", "usage"];
export const OPS_ALERTS_KEY = ["studio", "ops", "alerts"];
export const OPS_MAINTENANCE_KEY = ["studio", "ops", "maintenance"];
export const OPS_SEARCH_KEY = ["studio", "ops", "search"];

export const DEV_KEYS_KEY = ["studio", "dev", "keys"];
export const DEV_WEBHOOKS_KEY = ["studio", "dev", "webhooks"];
export const DEV_LOGS_KEY = ["studio", "dev", "logs"];
export const DEV_AUTOMATION_KEY = ["studio", "dev", "automation"];
export const DEV_CLI_KEY = ["studio", "dev", "cli"];
export const DEV_SDK_KEY = ["studio", "dev", "sdk"];
export const DEV_INTEGRATIONS_KEY = ["studio", "dev", "integrations"];

export const DESKTOP_PREFS_KEY = ["studio", "desktop", "preferences"];
export const DESKTOP_WORKSPACE_KEY = ["studio", "desktop", "workspace"];

export const CLOUD_OVERVIEW_KEY = ["studio", "cloud", "overview"];
export const CLOUD_SETTINGS_KEY = ["studio", "cloud", "settings"];
export const CLOUD_JOBS_KEY = ["studio", "cloud", "jobs"];
export const CLOUD_SCHEDULER_KEY = ["studio", "cloud", "scheduler"];
export const CLOUD_WEBHOOKS_KEY = ["studio", "cloud", "webhooks"];
export const CLOUD_WEBHOOK_HISTORY_KEY = ["studio", "cloud", "webhook-history"];
export const CLOUD_API_KEY = ["studio", "cloud", "api"];
export const CLOUD_LOGS_KEY = ["studio", "cloud", "logs"];
export const CLOUD_STORAGE_KEY = ["studio", "cloud", "storage"];
export const CLOUD_TELEMETRY_KEY = ["studio", "cloud", "telemetry"];
export const CLOUD_UPDATES_KEY = ["studio", "cloud", "updates"];
export const CLOUD_NODES_KEY = ["studio", "cloud", "nodes"];
export const CLOUD_METRICS_KEY = ["studio", "cloud", "metrics"];
export const CLOUD_AUTOMATION_KEY = ["studio", "cloud", "automation"];

export const RELEASE_BUILDS_KEY = ["studio", "release", "builds"];
export const RELEASE_DEPLOYMENTS_KEY = ["studio", "release", "deployments"];
export const RELEASE_BACKUPS_KEY = ["studio", "release", "backups"];
export const RELEASE_REPORTS_KEY = ["studio", "release", "reports"];
export const RELEASE_ERRORS_KEY = ["studio", "release", "errors"];
export const RELEASE_READINESS_KEY = ["studio", "release", "readiness"];
export const RELEASE_DATABASE_KEY = ["studio", "release", "database"];
export const RELEASE_PERFORMANCE_KEY = ["studio", "release", "performance"];
export const RELEASE_SECURITY_KEY = ["studio", "release", "security"];

export const AI_SESSIONS_KEY = ["studio", "ai", "sessions"];
export const AI_HISTORY_KEY = ["studio", "ai", "history"];
export const AI_PROMPTS_KEY = ["studio", "ai", "prompts"];
export const AI_SCHEMA_CACHE_KEY = ["studio", "ai", "schema"];
export const AI_INSIGHTS_KEY = ["studio", "ai", "insights"];

export const AGENTS_KEY = ["studio", "agents"];
export const AGENT_TASKS_KEY = ["studio", "agents", "tasks"];
export const AGENT_SCHEDULES_KEY = ["studio", "agents", "schedules"];
export const AGENT_WORKFLOWS_KEY = ["studio", "agents", "workflows"];
export const AGENT_HISTORY_KEY = ["studio", "agents", "history"];
export const AGENT_APPROVALS_KEY = ["studio", "agents", "approvals"];
export const AGENT_EVENTS_KEY = ["studio", "agents", "events"];
export const AGENT_RECOMMENDATIONS_KEY = ["studio", "agents", "recommendations"];
export const AGENT_TIMELINE_KEY = ["studio", "agents", "timeline"];
export const AGENT_HEALTH_KEY = ["studio", "agents", "health"];
export const AGENT_METRICS_KEY = ["studio", "agents", "metrics"];
export const AGENT_RULES_KEY = ["studio", "agents", "rules"];

export const WORKFLOWS_KEY = ["studio", "workflows"];
export const WORKFLOW_RUNS_KEY = ["studio", "workflows", "runs"];
export const WORKFLOW_TEMPLATES_KEY = ["studio", "workflows", "templates"];
export const WORKFLOW_HISTORY_KEY = ["studio", "workflows", "history"];
export const WORKFLOW_TRIGGERS_KEY = ["studio", "workflows", "triggers"];
export const WORKFLOW_APPROVALS_KEY = ["studio", "workflows", "approvals"];
export const WORKFLOW_LOGS_KEY = ["studio", "workflows", "logs"];
export const WORKFLOW_VARIABLES_KEY = ["studio", "workflows", "variables"];
export const WORKFLOW_METRICS_KEY = ["studio", "workflows", "metrics"];

/** Placeholder stored when secrets are masked for UI — never written to Firestore. */
export const SECRET_MASK = "••••••••";
